import { defineMessages } from 'react-intl';

export default defineMessages({
	heading: {
		id: 'discountLanding.invest.heading',
		defaultMessage: 'Invest in your best self',
		description: 'Heading for invest in yourself section',
	},
	subheading: {
		id: 'discountLanding.invest.subheading',
		defaultMessage: 'When using Calm, users report a boost in well-being.*',
		description: 'Description of general wellness boost via Calm use',
	},
	item1Heading: {
		id: 'discountLanding.invest.item1Heading',
		defaultMessage: 'Stress less',
		description: 'Heading for stress stat',
	},
	item1Stat: {
		id: 'discountLanding.invest.item1Stat',
		defaultMessage: '90%',
		description: 'Percentage that stress less when using Calm',
	},
	item1Description: {
		id: 'discountLanding.invest.item1Description',
		defaultMessage: 'Reported less anxiety',
		description: 'Explanation for stress stat',
	},
	item2Heading: {
		id: 'discountLanding.invest.item2Heading',
		defaultMessage: 'Sleep better',
		description: 'Heading for sleep stat',
	},
	item2Stat: {
		id: 'discountLanding.invest.item2Stat',
		defaultMessage: '92%',
		description: 'Percentage that sleep better when using Calm',
	},
	item2Description: {
		id: 'discountLanding.invest.item2Description',
		defaultMessage: 'Expressed higher quality sleep',
		description: 'Explanation of sleep better stat',
	},
	item3Heading: {
		id: 'discountLanding.invest.item3Heading',
		defaultMessage: 'Feel happier',
		description: 'Heading for happiness stat',
	},
	item3Stat: {
		id: 'discountLanding.invest.item3Stat',
		defaultMessage: '73%',
		description: 'Percentage that feel happier when using Calm',
	},
	item3Description: {
		id: 'discountLanding.invest.item3Description',
		defaultMessage: 'Improved mental health',
		description: 'Explanation for feel happier stat',
	},
	disclaimer: {
		id: 'discountLanding.invest.disclaimer',
		defaultMessage:
			'*Based on a study using survey data from subscribers who used the app 5+ times per week.',
		description: 'Disclaimer explaining that testimonial is based on user survey',
	},
	cta: {
		id: 'discountLanding.invest.cta',
		defaultMessage: 'Get Calm Premium',
		description: 'Button copy leading user to payment page',
	},
});
